import React from "react";
import { Chart as ChartJS,CategoryScale,LinearScale,BarElement,Title,Tooltip,Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register( CategoryScale,LinearScale,BarElement,Title,Tooltip,Legend,ChartDataLabels );

export default function LikelihoodToSwitchBarChart({ likelihoodQueryResults }) {

    if ( !Array.isArray(likelihoodQueryResults) || likelihoodQueryResults.length === 0 ) {
        return (
            <div className="App h-w-100 white-color">
                <p className="text-black ms-4">No data available!</p>
            </div>
        );
    }
    // Get labels from dynamic data
    const labels = likelihoodQueryResults.map( (item) => item.likelihood_to_switch_lic );
    // Get values from dynamic data
    // const values = likelihoodQueryResults.map( (item) => Number(item.respondent_count)/Number(item.total_respondents) || 0 );
    const values = likelihoodQueryResults.map((item) => {
        const count = Number(item.respondent_count) || 0;
        const total = Number(item.total_respondents) || 0;

        return total > 0 ? Number(((count / total) * 100).toFixed(2)) : 0;
    });
    const data = {
        labels: labels,
        datasets: [
            {
                label: "Likelihood to Switch",
                data: values,
                backgroundColor: "#f06b22",
                borderColor: "#f06b22",
                borderWidth: 1,
                borderRadius: 10,
                borderSkipped: false,
                barPercentage: 0.5,
                categoryPercentage: 0.7,
                datalabels: {
                    color: (context) => {
                        const value = context.dataset.data[context.dataIndex];
                        return value === 0 ? "#313932" : "#fff";
                    },
                    font: {
                        size: window.innerWidth < 767 ? 10 : 12,
                        family: "Graphik-Semibold, sans-serif",
                    },
                },
            },
        ],
    };
    const options = {
        indexAxis: "y",
        responsive: true,
        // maintainAspectRatio: window.innerWidth < 767 ? false : true,
        maintainAspectRatio: false,
        scales: {
            x: {
                beginAtZero: true,
                grid: {
                    color: "#424242",
                    display: false,
                },
                ticks: {
                    display: false,
                    color: "#ffffff",
                    font: {
                        family: "Graphik-Light, sans-serif",
                        size: window.innerWidth > 767 ? 8 : 10,
                    },
                },
                border: {
                    display: false,
                },
            },
            y: {
                grid: {
                    color: '#424242',
                    display: false,
                },
                ticks: {
                    font: () => ({
                        size: window.innerWidth < 1100 ? 10 : 15,
                        family: 'Graphik-Light, sans-serif',
                        weight: '500',
                        color: 'rgb(49, 57, 50)',
                    }),
                    align: 'center',
                    padding: 10,
                    crossAlign: 'far',
                },
                border: {
                    display: false,
                },
                // Reduce the gap between the bars
                categoryPercentage: 1,
                barPercentage: 0.8,
            }
        },
        plugins: {
            legend: {
                display: false,
                labels: {
                    color: "#ffffff",
                    font: {
                        family: "Graphik-Light, sans-serif",
                    },
                },
            },
            datalabels: {
                font: (context) => {
                    return {
                        size: window.innerWidth < 1100 ? 10 : 15,
                        family: "Graphik-Light, sans-serif",
                        color: "#313932",
                    };
                },
                color: "#ffffff",
                formatter: (value) => `${value}%`,
                align: (context) => {
                    const value = context.dataset.data[context.dataIndex];
                    return value <= 1 && value >= 0 ? "end" : "start";
                },
                anchor: (context) => {
                    const value = context.dataset.data[context.dataIndex];
                    return value <= 1 && value >= 0 ? "end" : "end";
                },
            },
            tooltip: {
                callbacks: {
                    title: function (tooltipItem) {
                        return tooltipItem[0].label;
                    },
                    label: function (tooltipItem) {
                        const value = tooltipItem.raw;
                        const dataIndex = tooltipItem.dataIndex;
                        const respondentCount = likelihoodQueryResults[dataIndex] ?.tot_val ?? "N/A";
                        return `Likelihood to Switch: ${value}% | Count: ${respondentCount}`;
                    },
                },
                titleFont: {
                    family: "Graphik-Light, sans-serif",
                    size: 12,
                },
                bodyFont: {
                    family: "Graphik-Light, sans-serif",
                    size: 10,
                },
                footerFont: {
                    family: "Graphik-Light, sans-serif",
                    size: 10,
                },
            },
        },
        layout: {
            padding: {
                top: 0,
                right: 20,
                bottom: 20,
                left: 12,
            },
        },
    };

    return (
        <div className="container-fluid">
            <div className="card mb-4">
                <div className="card-body"></div>
                <h5 className="mb-3"> Likelihood to Switch </h5>
                <div className="App metricChart h-w-100" style={{ height: "250px" }}>
                    <Bar data={data} options={options} />
                </div>
            </div>
        </div>
    );
}